import React, { useContext, useState, useEffect } from "react";
import NewUserAuditFormComponent from "./NewUserAuditForm";

function AuditFormComponent({
  setFormOpen,
  setOpenSnackbar,
  setSeverity,
  setMessage,
  setalertTitle,
  mobNo,
  lotNum,
  mobNum,
  FormMobileNo,
  typeOfUser,
  auditMobNum,
  auditLotNum,
  auditName,
  auditZone,
  setAuditLotNum,
  setAuditName,
  setAuditZone,
  callID,
  callType
}) {
  return (
    <>
      <>
        <NewUserAuditFormComponent
          setOpenSnackbar={setOpenSnackbar}
          setSeverity={setSeverity}
          setMessage={setMessage}
          setalertTitle={setalertTitle}
          FormMobileNo={FormMobileNo}
          typeOfUser={typeOfUser}
          setFormOpen={setFormOpen}
          auditMobNum={auditMobNum}
          auditLotNum={auditLotNum}
          auditName={auditName}
          auditZone={auditZone}
          setAuditLotNum={setAuditLotNum}
          setAuditName={setAuditName}
          setAuditZone={setAuditZone}
          callID={callID}
          callType={callType}
        ></NewUserAuditFormComponent>
      </>
    </>
  );
}

export default AuditFormComponent;
